import Backbone from 'backbone';

import View from './view';





export default View.extend( {

    initialize(options = {}) {
        View.prototype.initialize.call( this, options );
        this.$el.find( '.modal' ).modal( { show: false } );
    },
    
    // todo: setElement
    template: 'jst/modal',
    
    events: {
        
        // todo: enabled/disabled
        'click .action-accept': function() {
            this.trigger( 'ok' );
        },
        
        'click .action-reject': function() {
            this.trigger( 'reject' );
            this.close();
        },
        
        'keyup': function(e) {
            if (13 === e.keyCode) 
                if (this.$primary().length && !this.$primary()[0].disabled)
                    this.trigger( 'ok' );
        }
        
    },
    
    open(view) {
        // already there?
        if (this.$el.closest( 'body' ).length)
            this.$el.find( '.modal' ).addClass( 'in' );
        else 
            this.$el.appendTo( document.body )
                .find( '.modal-body' ).append( view && view.el ),
            setTimeout( () => this.$el.find( '.modal' ).addClass( 'in' ), 0 ),
            setTimeout( () => view.focus && view.focus(), 150 );

        if (view.undelegateEvents)
            view.undelegateEvents();
        if (view.delegateEvents)
            view.delegateEvents();   
        if (this.undelegateEvents)   
            this.undelegateEvents();
        if (this.delegateEvents)
            this.delegateEvents();
    },

    serialize() {
        return {
            large: this.options.large,
            medium: this.options.medium,
        }
    },
    
    close() {
        this.$el.find( '.modal' ).removeClass( 'in' );

        this.trigger( 'hide' );
        setTimeout( () => this.trigger( 'hidden' ), 150 );
    },
    
    $primary() {
        return this.$el.find( '.modal-footer .btn-primary' );
    },
    
    $accept() {
        return this.$el.find( '.modal-footer .action-accept' );
    },
    
    $reject() {
        return this.$el.find( '.modal-footer .action-reject' );
    },

} );


// WEBPACK FOOTER //
// ./src/js/view/modal.js